/* global google */
// do not delete above line. Needed for google address to function

import { basicAccountInfo } from "api/basic_account_info";
import {  generic_get_api, generic_post_api } from "api/generic_api";
import { Component, createRef, useEffect, useState } from "react";
import { Button, Modal } from 'react-bootstrap';
import { CODE_ZONING, SF_PROPERTY_INFO, CODE_ZONING_START } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import file_lines_light_full from 'assets/reputation/file-lines-light-full.svg';
import { truncateText } from "utils/helpers";
import  LoadingAnimation  from "pages/code_guide/loading_animation"


class CodeZoning extends Component {

    constructor(props) {
        super(props);

        this.state = {
            working: false,
            zoning_category_list: [],
            current_category: null,
            zoning_category_data_map: {},
            subcategory_visibility_map: {},
            property_address: null,
            expand_property_info: false,
            request_full_report: null,
            show_use_definition_modal: false,
            selected_use_term: null,
            selected_use_definition_list: null,
            checked_uses: [],
            selected_rules_list_entry: null,
        };
        this.resetAndSubmit = this.resetAndSubmit.bind(this);
        this.fetchZoningCategoryList = this.fetchZoningCategoryList.bind(this);
        this.fetchZoningCategory = this.fetchZoningCategory.bind(this);
        this.fetchZoningCategoryWithDelay = this.fetchZoningCategoryWithDelay.bind(this);
        this.setPropertyAddress = this.setPropertyAddress.bind(this);
        this.getPropertyInfo = this.getPropertyInfo.bind(this);
        this.newSearch = this.newSearch.bind(this);
        this.hideAnimation = this.hideAnimation.bind(this);
    }

    resetAndSubmit() {
        this.setState({ 
            working: false,
            zoning_category_list: [],
            current_category: null,
            zoning_category_data_map: {},
            subcategory_visibility_map: {},
            show_use_definition_modal: false,
            selected_use_term: null,
            selected_use_definition_list: null,
            selected_rules_list_entry: null,
        }, this.fetchZoningCategoryList);
    }

    newSearch() {
        this.setState({ 
            working: false,
            zoning_category_list: [],
            current_category: null,
            zoning_category_data_map: {},
            subcategory_visibility_map: {},
            property_address: null,
            expand_property_info: false,
            request_full_report: null,
            show_use_definition_modal: false,
            selected_use_term: null,
            selected_use_definition_list: null,
            selected_rules_list_entry: null,
            checked_uses: [],
        });
    }

    fetchZoningCategoryList() {
        this.setState({working: true});

        let request = {
            category_list: true,
            checked_uses: this.state.checked_uses,
            request_full_report: this.state.request_full_report,
        }

        generic_post_api(request, CODE_ZONING)
        .then(
            result => {
                return result.data.json()
            }
        ).then(
            data => {
                
                let zoning_category_data_map = {};

                if(data.zoning_category_list && data.zoning_category_list.length > 0) {
                    data.zoning_category_list.forEach((leven_1_category) => {
                        let level_2_categories = leven_1_category.sub_categories;

                        level_2_categories.forEach((leven_2_category) => {
                            let level_3_categories = leven_2_category.zoning_categories;
                            
                            level_3_categories.forEach((leven_3_category) => {
                                zoning_category_data_map[leven_3_category.db_name] = null;
                            });
                        })
                    });

                    this.setState({
                        working: false,
                        zoning_category_list: data.zoning_category_list,
                        zoning_category_data_map: zoning_category_data_map,
                        fetching_results: true,
                    }, () => {
                        let delay = 0;

                        Object.entries(zoning_category_data_map).map(([category, _]) => {
                            this.fetchZoningCategoryWithDelay(category, delay);
                            delay += 1000;
                        });
                    }
                    );
                    this.hideAnimation();
                }
            }
        )
        .catch(error => {
        });
    }

    fetchZoningCategoryWithDelay(category, delay) {
        const timeId = setTimeout(() => {
            this.fetchZoningCategory(category);
        }, delay);
    }

    hideAnimation() {
        const timeId = setTimeout(() => {
            this.setState({fetching_results: false});
        }, 60000);
    }

    fetchZoningCategory(category) {
        
        let request_params = {
            category_list: false, 
            zoning_category: category, 
            property_key: this.state.property_address.property_key,
            district: this.state.property_address.use_district,
            spuds: this.state.property_address.special_use_districts,
            height: this.state.property_address.height_district,
            checked_uses: this.state.checked_uses,
        }

        generic_post_api(request_params, CODE_ZONING)
        .then(
            result => {
                return result.data.json()
        })
        .then(
            data => {
                let zoning_category_data_map = this.state.zoning_category_data_map;
                zoning_category_data_map[category] = data;

                this.setState({
                    zoning_category_data_map: zoning_category_data_map
                });
            }
        )
        .catch(error => {
        });
    }

    setPropertyAddress(address) {
        this.setState(
            {property_address: address}, 
            () => this.getPropertyInfo()
        );
    }

    getPropertyInfo() {

        if (this.state.property_address){

            let query_params = {
                lat: this.state.property_address.lat,
                lng: this.state.property_address.lng,
                street_number: this.state.property_address.street_number,
                street_name: this.state.property_address.street_name,
            }

            generic_get_api(SF_PROPERTY_INFO, query_params)
            .then(
                data => {
                    let cur_address = this.state.property_address;
                    cur_address.use_district = data.use_district;
                    cur_address.height_district = data.height_district;
                    cur_address.special_use_districts = data.special_use_districts;
                    cur_address.property_key = data.property_key;

                    this.setState({property_address: cur_address});
                }
            )
            .catch(error => {
            });

            generic_get_api(CODE_ZONING_START, {})
            .then(
                data => {
                    this.setState({
                        all_uses_map: data.all_uses,
                        top_level_uses: data.top_level_uses,
                    });
                }
            )
            .catch(error => {
            });
        }
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'code_zoning'});

        basicAccountInfo()
        .then(
            data => {
                this.setState({session_ok: true});
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });
    }

    render() {
        const {selected_use_term, checked_uses, selected_use_definition_list, show_use_definition_modal, request_full_report, 
            working, zoning_category_list, top_level_uses, current_category, zoning_category_data_map, subcategory_visibility_map, 
            property_address, expand_property_info, all_uses_map, selected_rules_list_entry, fetching_results} = this.state;

        const getCurrentSummary = () => {

            if (current_category && 
                zoning_category_data_map[current_category] && 
                zoning_category_data_map[current_category].summary && 
                zoning_category_data_map[current_category].summary.length > 0) {
                
                return zoning_category_data_map[current_category].summary;
            }
            else {
                return [];
            }
                
        }

        const getRulesList = () => {
            if (current_category && 
                zoning_category_data_map[current_category] && 
                zoning_category_data_map[current_category].formatted_output_list && 
                zoning_category_data_map[current_category].formatted_output_list.length > 0) {
                
                return zoning_category_data_map[current_category].formatted_output_list;
            }
            else {
                return [];
            }
        }

        const getBulletins = () => {
            if (current_category && 
                zoning_category_data_map[current_category] && 
                zoning_category_data_map[current_category].bulletins && 
                zoning_category_data_map[current_category].bulletins.length > 0) {
                
                return zoning_category_data_map[current_category].bulletins;
            }
            else {
                return [];
            }
        }

        const toggleSpecialRules = (rules_index) => {
            let current_zoning_category_data_map = zoning_category_data_map;
            let zoning_category_data = current_zoning_category_data_map[current_category];
            let existing_value = zoning_category_data.formatted_output_list[rules_index].show_special_rules
            zoning_category_data.formatted_output_list[rules_index].show_special_rules = !existing_value;
            current_zoning_category_data_map[current_category] = zoning_category_data;
            this.setState({zoning_category_data_map: current_zoning_category_data_map})
        }

        const toggleSubCategoryVisibility = (sub_name) => {
            let current_subcategory_visibility_map = subcategory_visibility_map;
            current_subcategory_visibility_map[sub_name] = !current_subcategory_visibility_map[sub_name];
            this.setState({subcategory_visibility_map: current_subcategory_visibility_map});
        }

        const expandCollapseUse = (use_name) => {
            let temp_all_use_map = all_uses_map;
            let use_entry = temp_all_use_map[use_name];
            use_entry.expanded = !use_entry.expanded;
            temp_all_use_map[use_name] = use_entry;
            this.setState({all_uses_map: temp_all_use_map});
        }

        const toggleUseDescriptionModal = (term, definition_list) => {
            this.setState({
                show_use_definition_modal: !show_use_definition_modal,
                selected_use_term: term,
                selected_use_definition_list: definition_list,
            })
        }

        const checkUncheckUse = (use_name) => {
            if (checked_uses.includes(use_name)){
                const new_arr = checked_uses.filter(item => item !== use_name);
                this.setState({checked_uses: new_arr});
            }
            else {
                checked_uses.push(use_name);
                this.setState({checked_uses: checked_uses});
            }
        }

        const canGetZoning = () => {
            return property_address && (request_full_report || checked_uses.length > 0);
        }

        return(
            <div class="container codeZoning ps-4">

                {this.state.session_ok && 
                    <>
                        <div class="row">
                            {
                                (!zoning_category_list || zoning_category_list.length === 0) && 
                                <div class="container mt-3" style={{width: "800px"}}>
                                    <div class="row"><div class="col fs-4 text-center">Zoning report</div></div>
                                    <div class="row mt-3">
                                        <div class="col-2"></div>
                                        <div class="col-8">
                                            <AddressSearchComponent 
                                                setPropertyAddress={this.setPropertyAddress}
                                                resetAndSubmit={this.resetAndSubmit}
                                                canGetZoning={canGetZoning}
                                            />
                                        </div>
                                        <div class="col-2"></div>
                                    </div>
                                    {
                                        property_address && all_uses_map && top_level_uses &&
                                        <div class="row mt-4">
                                            <div class="col-2"></div>
                                            <div class="col-auto pe-0">
                                                <input 
                                                    class="form-check-input" 
                                                    type="radio"
                                                    name="fullReportRadio" 
                                                    id="fullReportRadio1"
                                                    checked={request_full_report === true}
                                                    onChange={ (e) => this.setState({request_full_report: true}) }
                                                />
                                            </div>
                                            <div class="col-3">All uses</div>
                                            <div class="col-auto pe-0">
                                                <input 
                                                    class="form-check-input" 
                                                    type="radio"
                                                    name="fullReportRadio" 
                                                    id="fullReportRadio2"
                                                    checked={request_full_report === false}
                                                    onChange={ (e) => this.setState({request_full_report: false, checked_uses:[]})}
                                                />
                                            </div>
                                            <div class="col-3">Select uses</div>
                                            <div class="col-2"></div>
                                        </div>
                                    }
                                    {
                                        request_full_report === false &&
                                        <div class="row mt-5">
                                            <div class="col-8 border-end">
                                                <DefinitionModal
                                                    show_use_definition_modal={show_use_definition_modal}
                                                    selected_use_term={selected_use_term}
                                                    selected_use_definition_list={selected_use_definition_list}
                                                    toggleUseDescriptionModal={toggleUseDescriptionModal}
                                                />
                                                {
                                                    top_level_uses.map((entry_name) => {
                                                        return <UseEntry
                                                                    level={0}
                                                                    entry_name={entry_name}
                                                                    all_uses_map={all_uses_map}
                                                                    expandCollapseUse={expandCollapseUse}
                                                                    toggleUseDescriptionModal={toggleUseDescriptionModal}
                                                                    checked_uses={checked_uses}
                                                                    checkUncheckUse={checkUncheckUse}
                                                                />
                                                    })
                                                }
                                            </div>
                                            <div class="col-4">
                                                {
                                                    checked_uses.length > 0 && 
                                                    <>
                                                    <div class='row'><div class="col fw-semibold">Selected uses</div></div>
                                                    {
                                                        checked_uses.map((use) => {
                                                            return <div class='row'><div class="col"><i class="fa-solid fa-check fa-sm"></i>&nbsp;{use}</div></div>
                                                        })
                                                    }
                                                    </>
                                                }
                                            </div>
                                        </div>

                                    }
                                    <div class="row mt-5">
                                        <div class="col text-center">

                                        </div>
                                    </div>

                                </div>
                            }
                            {
                                zoning_category_list && zoning_category_list.length > 0 &&  
                                <div class="container propertyInfo">
                                    <div class="row mb-3">
                                        <div class="col"><Button onClick={this.newSearch}>New report&nbsp;<i class="fa-solid fa-plus"></i></Button></div>
                                    </div>

                                    <div class="row  border rounded p-3">
                                        <div class="row">
                                            <div class="col fw-semibold" role="button" onClick={() => this.setState({expand_property_info: !expand_property_info})}>
                                                {property_address.formatted_address}&nbsp;&nbsp;
                                                {
                                                    expand_property_info?
                                                    <i class="fa-solid fa-caret-down fa-xl"></i>
                                                    : 
                                                    <i class="fa-solid fa-caret-right  fa-xl"></i>
                                                }
                                            </div>
                                        </div>
                                        {
                                            expand_property_info && 

                                            <div class="row mt-3">
                                                <div class="col-auto">
                                                    <div class="row fw-lighter">
                                                        <div class="col">Use (Zone)</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">{property_address.use_district}</div>
                                                    </div>
                                                </div>
                                                <div class="col-auto">
                                                    <div class="row fw-lighter">
                                                        <div class="col">Height district</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">{property_address.height_district}</div>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div class="row fw-lighter">
                                                        <div class="col">Special use districts</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            {
                                                                property_address.special_use_districts.map((district, idx) => {
                                                                    if (idx < property_address.special_use_districts.length - 1) {
                                                                        return <>{district}&nbsp;&nbsp;&#x2022;&nbsp;&nbsp; </>
                                                                    }
                                                                    else{
                                                                        return <>{district}</>
                                                                    }
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </>
                }
                {
                    working && 
                    <div class="container mt-5 text-center">
                        <span class="spinner-border" aria-hidden="true"></span>
                    </div>
                }
                <div class="row mt-4">
                    <div class="col-3 overflow-auto categoriesList">
                        {
                            zoning_category_list.map((level_1_category) => {
                                return  <>
                                            <div className="row"><div class="col pb-1 pt-1">
                                                <i class={level_1_category.icon_name}></i>&nbsp;&nbsp;&nbsp;{level_1_category.name}</div>
                                            </div>
                                            {
                                                level_1_category.sub_categories.map((level_2_category) =>{
                                                    return  <>
                                                                <div className="row ms-3">
                                                                    <div class="col pb-1 pt-1 categoryHoverBox" role="button" onClick={() => toggleSubCategoryVisibility(level_2_category.name)}>
                                                                        
                                                                        {
                                                                            subcategory_visibility_map[level_2_category.name] ?
                                                                            <i class="fa-solid fa-caret-down"></i>
                                                                            : 
                                                                            <i class="fa-solid fa-caret-right"></i>
                                                                        }
                                                                        &nbsp;{level_2_category.name}
                                                                    </div>
                                                                                                                
                                                                </div>
                                                                {   subcategory_visibility_map[level_2_category.name] &&
                                                                    level_2_category.zoning_categories.map((zoning_category) => {
                                                                        return  <>
                                                                                    <div className={`row childUseLevel_${zoning_category.level}`}>
                                                                                            <div class={`col pb-1 pt-1 categoryHoverBox ${current_category === zoning_category.db_name ? "selected" : ""}`} 
                                                                                                role="button" onClick={()=>this.setState({current_category: zoning_category.db_name, selected_rules_list_entry: null })}>

                                                                                                <img src={file_lines_light_full} className="categoryIcon"/>
                                                                                                {zoning_category.name}
                                                                                                {
                                                                                                    zoning_category_data_map[zoning_category.db_name] === null && 
                                                                                                    <>
                                                                                                        &nbsp;&nbsp;
                                                                                                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                                                                    </>
                                                                                                }
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                    })
                                                                }
                                                            </>
                                                })
                                            }
                                            <div class="row">
                                                <div class="col">
                                                    <hr></hr>
                                                </div>
                                            </div>
                                        </>   
                                        
                            })
                        }
                    </div>
                    <div class="col-6">
                        {
                            fetching_results && current_category === null && 
                            <div class="container">
                                <LoadingAnimation />
                            </div>
                            
                        }
                        {getCurrentSummary().length > 0 && 
                            <div class="container p-2 rounded border bg-light">
                                <div class="row mb-2">
                                    <div class="col fw-semibold"><i class="fa-solid fa-circle-info"></i>&nbsp;Highlights</div>
                                </div>
                                <div class="row"><div class="col"><hr className="m-0"></hr></div></div>
                                {   
                                    getCurrentSummary().map((summary_entry) =>{
                                        return  <>
                                                { summary_entry.value && 
                                                    <div className="row mt-2">
                                                        <div class="col-4 border-end">{summary_entry.name}</div>
                                                        <div class="col-6 border-end">{summary_entry.value}</div>
                                                        <div class="col-2"><small>{summary_entry.references.join(", ")}</small></div>
                                                    </div>
                                                }
                                                </>
                                    })
                                }
                            </div>
                        }
                        { 
                            getRulesList().map((entry, rules_index) => {
                                return <>
                                   
                                        <div class={`container p-4 primarySummary mt-4 rounded border ${selected_rules_list_entry === entry ? "selected border-primary" : ""}`}>
                                            {
                                                entry.rule_rank === "0" &&
                                                <div class="row mb-2">
                                                    <div class="col fw-semibold text-warning">
                                                        <i class="fa-solid fa-triangle-exclamation"></i>&nbsp;
                                                        These rules may take precedence over other rules.
                                                    </div>
                                                </div>
                                            }
                                            <div class="row mb-4 text-center" role="button" onClick={() => {this.setState({selected_rules_list_entry: entry}); window.scroll(0, -100)}}>
                                                <div class="col fw-bold">SEC. {entry.section_title}</div>
                                            </div>
                                            {
                                                entry.primary_summaries.map(primary_summary => {
                                                    return  <>
                                                                 <div class="row mb-2">
                                                                    <div class="col fw-semibold text-secondary">{primary_summary.title}</div>
                                                                </div>
                                                                <div class="container">
                                                                    <ul>
                                                                    {   
                                                                        primary_summary.condition_list.map((condition_entry) =>{
                                                                            return  <li className="mb-2">
                                                                                            <span>{condition_entry.text_summary} <small>[{condition_entry.reference.join(", ")}]</small></span>
                                                                                        </li>
                                                                                    
                                                                        })
                                                                    }
                                                                    </ul>
                                                                </div>
                                                            </>
                                                })
                                            }
                                           
                                            {
                                                entry.special_rules_summaries.map(special_rules_summary=>{
                                                    return <>
                                                            <div class="row mt-4">
                                                                <div class="col fw-semibold text-secondary">
                                                                    <a className="text-decoration-none text-secondary" 
                                                                        onClick={() => toggleSpecialRules(rules_index)} role="button">
                                                                        Special cases&nbsp;
                                                                        {   
                                                                            entry.show_special_rules ? 
                                                                            <i class="fa-solid fa-caret-down fa-xl"></i>
                                                                            : 
                                                                            <i class="fa-solid fa-caret-right fa-xl"></i>
                                                                        }
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            {
                                                                entry.show_special_rules && 
                                                                <div class="container">
                                                                    <ul>
                                                                    {   
                                                                        special_rules_summary.condition_list.map((condition_entry) =>{
                                                                            return  <li className="mb-2">
                                                                                            <span>{condition_entry.text_summary} <small>[{condition_entry.reference.join(", ")}]</small></span>
                                                                                        </li>
                                                                                    
                                                                        })
                                                                    }
                                                                    </ul>
                                                                </div>
                                                            }
                                                        </>
                                                })
                                            } 
                                        </div>
                                
                                </>
                            })
                        } 
                        {/* { 
                            getRulesList().map((entry, rules_index) => {
                                return <>
                                    {
                                        entry.primary_summary && 
                                        <div class={`container p-4 primarySummary mt-4 rounded border ${selected_rules_list_entry === entry ? "selected border-primary" : ""}`}
                                            role="button" onClick={() => this.setState({selected_rules_list_entry: entry})}
                                        >
                                            <div class="row mb-4 text-center">
                                                <div class="col fw-bold">SEC. {entry.section_title}</div>
                                            </div>
                                            {
                                                entry.rule_rank === "0" &&
                                                <div class="row mb-2">
                                                    <div class="col fw-semibold text-warning">
                                                        <i class="fa-solid fa-triangle-exclamation"></i>&nbsp;
                                                        These rules may take precedence over other rules.
                                                    </div>
                                                </div>
                                            }
                                            <div class="row mb-2">
                                                <div class="col fw-semibold text-secondary">{entry.primary_summary.title}</div>
                                            </div>
                                            <div class="container">
                                                <ul>

                                                
                                                {   
                                                    entry.primary_summary.condition_list.map((condition_entry) =>{
                                                        return  <li className="mb-2">
                                                                        <span>{condition_entry.text_summary} <small>[{condition_entry.reference.join(", ")}]</small></span>
                                                                    </li>
                                                                
                                                    })
                                                }
                                                </ul>
                                            </div>
                                            {
                                                entry.special_rules_summary && 
                                                <>
                                                    <div class="row mt-4">
                                                        <div class="col fw-semibold text-secondary">
                                                             <a className="text-decoration-none text-secondary" 
                                                                onClick={() => toggleSpecialRules(rules_index)} role="button">
                                                                Special cases&nbsp;
                                                                {   
                                                                     entry.show_special_rules ? 
                                                                     <i class="fa-solid fa-caret-down fa-xl"></i>
                                                                     : 
                                                                    <i class="fa-solid fa-caret-right fa-xl"></i>
                                                                }
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {
                                                        entry.show_special_rules && 
                                                        <div class="container">
                                                            <ul>
                                                            {   
                                                                entry.special_rules_summary.condition_list.map((condition_entry) =>{
                                                                    return  <li className="mb-2">
                                                                                    <span>{condition_entry.text_summary} <small>[{condition_entry.reference.join(", ")}]</small></span>
                                                                                </li>
                                                                            
                                                                })
                                                            }
                                                            </ul>
                                                        </div>
                                                    }
                                                </>
                                            }
                                            
                                        </div>
                                    }
                                </>
                            })
                        }  */}
                        {   getBulletins().map((bulletin) => {
                                return <div>
                                    {
                                        <div class="container p-4 primarySummary mt-4 rounded border">
                                            <div class="row mb-4 text-center">
                                                <div class="col fw-bold">
                                                    <a role="button" className="text-decoration-none text-black" href={bulletin.external_url} target="_blank">
                                                        Bulletin {bulletin.bulletin_number}:&nbsp;{bulletin.title}&nbsp;<i class="fa-solid fa-up-right-from-square"></i>
                                                    </a>
                                                </div>
                                            </div>
                                           
                                            <div class="row mb-2">
                                                <div class="col ">{bulletin.summary}</div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            })
                        } 
                    </div>
                    <div class="col-3">
                        <SideBar 
                            entry={selected_rules_list_entry}
                        />
                    </div>

                </div>
                
            </div>
        )
    }
}

function SideBar(props) {

    const {entry} = props;

    if (!entry) {
        return null;
    }

    return(
        <div class="container border rounded grayBackground p-3">
            <div class="row">
                <div class="col fw-bold fs-5">SEC. {entry.section_id}&nbsp;
                <a href={`/code/code_sections?section_id=${entry.section_id}`} className="text-decoration-none" target="_blank" role="button">
                    <i class="fa-solid fa-arrow-up-right-from-square fa-xs"></i></a>
                </div>
            </div>
            <div class="row mt-2"><div class="col fw-semibold fs-6">{entry.section_details.section_title}</div></div>
            <div class="row mt-2">
                <div class="col" style={{display: "flex", flexWrap: "wrap", rowGap: "5px"}}>
                    { entry.section_details.topics.map((topic) => {
                        return <span className="resultTopicLabel me-1 ps-1 pe-1" role="button" style={{"whiteSpace": "nowrap"}}>{topic}</span>
                    })}
                </div>
            </div>
            <DefinitionsComponent 
                definitions = {entry.section_details.definitions}
            />
            <ReferencesComponent links={entry.section_details.outgoing_links} title="References"/>
            <ReferencesComponent links={entry.section_details.incoming_links} title="Referenced in"/>
        </div>
    )
}

function DefinitionsComponent(props) {
    const {definitions} = props;
    const [expanded, setExpanded] = useState(false);
    const [show_definition_modal, setShowDefinitionModal] = useState(false);
    const [selected_definition, setSelectedDefinition] = useState(null);

    const text_excerpt = (definition) => {
        let all_text = "";

        definition.text_parts.forEach((item) => {
            all_text += " " + item.text;
        });

        return truncateText(all_text, 100, true);
    }

    if (!definitions || definitions.length <= 0) {
        return null;
    }
    
    return( <div class="row mt-4 ms-2 me-2 p-3 border rounded whiteBackground">
                <div class="row mb-1" onClick={() => setExpanded(!expanded)} role="button">
                    <div class="col fw-bold">
                        {
                            expanded ? <i class="fa-solid fa-angle-down"></i> : <i class="fa-solid fa-angle-right"></i>
                        }
                        &nbsp;&nbsp;<i class="fa-solid fa-spell-check"></i>&nbsp;&nbsp;Definitions
                    </div>
                </div>
                {
                    expanded && definitions.map(definition => {
                        return  <div class="container mt-4">
                                    <div class="row"><div class="col fw-semibold text-primary">{definition.term}</div></div>
                                    <div class="row mt-2"><div class="col text-secondary">{text_excerpt(definition)}</div></div>
                                    <div class="row mt-2" role="button" onClick={() => {setSelectedDefinition(definition); setShowDefinitionModal(true)}}>
                                        <div class="col"><i class="fa-solid fa-up-right-and-down-left-from-center"></i>&nbsp; Expand</div>
                                    </div>
                                </div>
                    })
                }
                <DefinitionSideModal
                    show_definition_modal={show_definition_modal}
                    setShowDefinitionModal={setShowDefinitionModal}
                    definition={selected_definition}
                />

            </div>
    )
}

function DefinitionSideModal(props) {

    const { show_definition_modal, setShowDefinitionModal, definition } = props;

    const getMargin = (part) => {

        if(part.level === 1){
            return "row mt-1 margin_subsection_1";
        }
        else if(part.level === 2){
            return "row mt-1 margin_subsection_2";
        }
        else if(part.level === 3){
            return "row mt-1 margin_subsection_3";
        }
        else if (part.level === 4) {
            return "row mt-1 margin_subsection_4";
        }
        else if (part.level === 5) {
            return "row mt-1 margin_subsection_5";
        }
        else {
            return "row";
        }
    }

    if (! definition) {
        return <></>
    }

    return (
        <Modal
            show={show_definition_modal}
            onHide={() => setShowDefinitionModal(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{definition.term}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div class="container definitionDetailModal">
                   {
                        definition.text_parts.map(part => {
                            return  <div class={getMargin(part)}>
                                        {
                                            part.level === 0 ? 
                                                <div class="col">{part.text}</div>
                                            :
                                            <>
                                                { part.subsection ?
                                                    <>
                                                        {part.level < 4?
                                                            <div class="col-1 pe-0 ps-0 subsection">({part.subsection})</div> 
                                                            :
                                                            <div class="col-1 pe-0 ps-0 subsection">{part.subsection}.</div>
                                                        }
                                                    </>
                                                    
                                                    :
                                                    <div class="col-1 pe-0 ps-0 subsection">&nbsp;&nbsp;&nbsp;</div>
                                                }
                                                
                                                <div class="col">{part.text}</div>
                                            </>

                                        }
                                    </div>
                        })
                   }
                </div>
            </Modal.Body>
        </Modal>
    )
}

function ReferencesComponent(props) {
    const {links, title} = props;
    const [expanded, setExpanded] = useState(false);

    // Collapse the links when a new entry is selected.
    useEffect(() => {
        setExpanded(false);
    }, [links]);

    return (<div class="row mt-4 ms-2 me-2 p-3 border rounded whiteBackground">
                {
                    links && links.length > 0 &&
                    <>
                        <div class="row mb-1" onClick={() => setExpanded(!expanded)} role="button">
                            <div class="col fw-bold">
                                {
                                    expanded ? <i class="fa-solid fa-angle-down"></i> : <i class="fa-solid fa-angle-right"></i>
                                }
                                &nbsp;&nbsp;<i class="fa-solid fa-link"></i>&nbsp;{title}
                            </div>
                        </div>
                        {
                            expanded && links.map(link => {
                                return  <div class="container mt-4">
                                            <div class="row">
                                                <div class="col fw-semibold">
                                                    <a role="button" href={`/code/code_sections?section_id=${link.section_id}`} target="_blank"
                                                        className="text-decoration-none fw-semibold text-primary">SEC. {link.section_id}&nbsp;
                                                        <i class="fa-solid fa-arrow-up-right-from-square fa-xs"></i></a>
                                                </div>
                                            </div>
                                            <div class="row mt-1"><div class="col text-secondary fw-semibold">{link.title}</div></div>
                                            <div class="row mt-2"><div class="col text-secondary">{truncateText(link.summary, 100, true)}</div></div>
                                            <div class="row mt-2">
                                                <div class="col" style={{display: "flex", flexWrap: "wrap", rowGap: "5px"}}>
                                                    { link.topics.map((topic) => {
                                                        return <span className="resultTopicLabel me-1 ps-1 pe-1" role="button" style={{"whiteSpace": "nowrap"}}>{topic}</span>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                            })
                        }
                    </>
                }
            </div>
    )
}

function UseEntry(props) {
    const {entry_name, level, checked_uses, checkUncheckUse, all_uses_map, expandCollapseUse, toggleUseDescriptionModal} = props;
    const use_entry = all_uses_map[entry_name];

    const getClassName = () => {
        return "useRowEntry row mt-1 margin_start_" + level; 
    }

    return(
        <>
        <div class={getClassName()}>
            <div class="col">

                {
                    !use_entry.is_leaf ?
                    <>
                        <span onClick={() => expandCollapseUse(entry_name)} role="button">
                            {
                                use_entry.expanded ?
                                <i class="fa-solid fa-caret-down fa-xl"></i>
                                : 
                                <i class="fa-solid fa-caret-right fa-xl"></i>
                            }
                             &nbsp;{entry_name}&nbsp;
                        </span>
                        <span role="button" onClick={() => toggleUseDescriptionModal(entry_name, use_entry.definition)}><i class="fa-regular fa-circle-question"></i></span>
                    </>
                    :
                    <span>
                        <input 
                            class="form-check-input" 
                            type="checkbox"
                            name={entry_name}
                            id={entry_name}
                            checked={checked_uses.includes(entry_name)}
                            onChange={ (e) => checkUncheckUse(entry_name) }
                        />
                        &nbsp;{entry_name}&nbsp;
                        <span role="button" onClick={() => toggleUseDescriptionModal(entry_name, use_entry.definition)}><i class="fa-regular fa-circle-question"></i></span>
                    </span>

                }
               
            </div>
        </div>
        {
            use_entry.expanded &&
                <>
                {
                    use_entry.children.map((child_name) => {
                        return <UseEntry
                            level={level + 1}
                            entry_name={child_name}
                            all_uses_map={all_uses_map}
                            expandCollapseUse={expandCollapseUse}
                            toggleUseDescriptionModal={toggleUseDescriptionModal}
                            checked_uses={checked_uses}
                            checkUncheckUse={checkUncheckUse}
                        />
                    })
                }
                </>
            }
        </>
    )
}

function DefinitionModal(props){

    const {toggleUseDescriptionModal, show_use_definition_modal, selected_use_term, selected_use_definition_list} = props;

    return (
        <Modal
            show={show_use_definition_modal}
            onHide={toggleUseDescriptionModal}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{selected_use_term}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div class="container">
                    {selected_use_definition_list && selected_use_definition_list.map((paragraph) => {
                        return <p>{paragraph}</p>
                    })}
                </div>
            </Modal.Body>
        </Modal>
    )
}

class AddressSearchComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            select_button_enabled: false,
        }

        this.autocompleteInput = createRef();
        this.autocomplete = null;
        
        this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
        this.addressChanged = this.addressChanged.bind(this);
        this.resetAddressField = this.resetAddressField.bind(this);
    }
      
    addressChanged(e) {
        // this.setState({
        //     address_field: e.target.value,
        // });
        this.props.setPropertyAddress(null);
    }

    resetAddressField() {
        this.autocompleteInput.current.value = "";
        this.props.setPropertyAddress(null);
    }

    componentDidMount() {

        const center = { lat: 37.75953994968017, lng: -122.44697911726526 };

        // Create a bounding box with sides ~10km away from the center point
        const defaultBounds = {
            north: center.lat + 0.07,
            south: center.lat - 0.07,
            east: center.lng + 0.07,
            west: center.lng - 0.07,
        };
        this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.current,
            {"types": ["geocode"], "fields": ["address_components", "formatted_address", "name", "geometry"], bounds: defaultBounds, strictBounds: true });

        this.autocomplete.addListener('place_changed', this.handlePlaceChanged);
    }

    handlePlaceChanged(){
        const place = this.autocomplete.getPlace();
        let streetNumber = '';
        let streetName = ''
        let city = '';
        let state = '';
        let zipCode = '';

        let i = 0;
        let lat = place.geometry.location.lat();
        let lng = place.geometry.location.lng();

        for(; i < place.address_components.length; i++) {
            let component = place.address_components[i];
            if (component.types.includes("street_number")) {
                streetNumber = component.long_name;
            }
            else if (component.types.includes("route")) {
                streetName = component.long_name;
            }
            else if (component.types.includes("locality")) {
                city = component.long_name;
            }
            else if (component.types.includes("administrative_area_level_1")) {
                state = component.short_name;
            }
            else if (component.types.includes("postal_code")) {
                zipCode = component.long_name;
            }
        }

        this.props.setPropertyAddress({
            street_number: streetNumber,
            street_name: streetName,
            city: city,
            state: state,
            zip_code: zipCode,
            formatted_address: place.formatted_address,
            lat: lat,
            lng: lng,
        });
    }

    render() {

        return( 
            <>
                <div class="row mt-1">
                    <div class="col">
                        <div class="input-group">
                            <input type="text" class="form-control" placeHolder="Address" ref={this.autocompleteInput}  id="autocomplete" onChange={ (e) => this.addressChanged(e) }/>
                            <Button onClick={this.props.resetAndSubmit} disabled={!this.props.canGetZoning()} role="button">
                                Get Zoning
                            </Button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

CodeZoning.displayName = "CodeZoning";
export default CodeZoning;